<template>
  <div class="loading">
    <img src="@/assets/icon.svg" alt="Loading logo" class="logo" />
    <div class="hollow-dots-spinner">
      <div class="dot"></div>
      <div class="dot"></div>
      <div class="dot"></div>
    </div>
    <span class="loading-message">{{ messages[currentMessage] }}</span>
  </div>
</template>

<script>
export default {
  name: "Loading",
  data() {
    let messages = [
      "Assembling your data.",
      "One moment…",
      "Hold your breath - won't be long",
      "Almost sorted."
    ];
    setInterval(() => {
      if (this.currentMessage === messages.length - 2) {
        this.currentMessage = 0;
      } else {
        this.currentMessage++;
      }
    }, 5000);

    return {
      currentMessage: 0,
      messages
    };
  }
};
</script>

<style scoped lang="scss">
.loading {
    display: flex;
    flex-direction: column;
    align-items: center;
}

.loading > * {
    margin-bottom: 1rem;
}

.hollow-dots-spinner,
.hollow-dots-spinner * {
  box-sizing: border-box;
}

.hollow-dots-spinner {
  height: 15px;
  width: calc(30px * 3);
}

.hollow-dots-spinner .dot {
  width: 15px;
  height: 15px;
  margin: 0 calc(15px / 2);
  border: calc(15px / 5) solid red;
  border-radius: 50%;
  float: left;
  transform: scale(0);
  animation: hollow-dots-spinner-animation 1000ms ease infinite 0ms;
}

.hollow-dots-spinner .dot:nth-child(1) {
  animation-delay: calc(300ms * 1);
}

.hollow-dots-spinner .dot:nth-child(2) {
  animation-delay: calc(300ms * 2);
}

.hollow-dots-spinner .dot:nth-child(3) {
  animation-delay: calc(300ms * 3);
}

@keyframes hollow-dots-spinner-animation {
  50% {
    transform: scale(1);
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.loading-message {
    color: red;
}

.logo {
    width: 5rem;
}
</style>